<template>
  <v-tabs
    centered="true"
    grow="true"
    fixed-tabs
    v-if="!cargando"
    slider-color="#06cbb3"
    color="#E6E6E6"
    @change="cambiarSolapa"
  >
    <v-tab
      :key="'reserva'"
      :href="'#tab-reserva'"
    >
      <v-icon small>zmdi zmdi-plus</v-icon>&nbsp;Reservar Turno
    </v-tab>
    <v-tab
      :key="'agenda'"
      :href="'#tab-agenda'"
    >
      <v-icon small>zmdi zmdi-calendar-alt</v-icon>&nbsp;Mis Turnos
    </v-tab>
    <v-tab
      :key="'estudios'"
      :href="'#tab-estudios'"
      v-if="puedoPermiso('pacientes_estudios', 'lectura')"
    >
      <v-icon small>zmdi zmdi-hospital-alt</v-icon>&nbsp;Mis Estudios
    </v-tab>

    <v-tab-item
      :key="'reserva'"
      :value="'tab-reserva'"
    >
      <v-stepper v-model="pasoTurno">
        <v-stepper-header>
          <v-stepper-step
            :complete="pasoTurno > 1"
            step="1"
          >Preferencias de turno</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            :complete="pasoTurno > 2"
            step="2"
          >Selección del turno</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            :complete="pasoTurno > 3"
            step=3
          >Documentación requerida</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="4">Finalizar</v-stepper-step>

        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <!-- PASO TURNO 1 -->
            <v-card
              flat
              tile
              v-if="pasoTurno == 1"
            >
              <v-card-text>
                <h5 class="text-center text--secondary pt-10">Ingrese los detalles del turno requerido y le ofreceremos las opciones más adecuadas.</h5>
                <h6
                  class="text-center pt-10 rojo"
                  v-if="!detalleTurno.cargando && detalleTurno.turnoAbierto && !detalleTurno.habilitadoMedico"
                >El turno solicitado fue aceptado y una vez que concurra al consultorio el profesional le habilitará los turnos restantes.</h6>
                <h6
                  class="text-center pt-10 verde"
                  v-if="!detalleTurno.cargando && !detalleTurno.turnoAbierto && detalleTurno.turnosDisponibles > 0"
                >Turnos restantes aprobados: {{detalleTurno.turnosDisponibles}}</h6>
                <h6
                  class="text-center pt-10 verde"
                  v-if="!detalleTurno.cargando && !(detalleTurno.turnoAbierto && !detalleTurno.habilitadoMedico) && !(!detalleTurno.turnoAbierto && detalleTurno.turnosDisponibles > 0)"
                >
                  Está por sacar un turno para su primer sesión de un grupo de sesiones.
                </h6>
                <v-form v-model="valid">
                  <v-container>
                    <v-row>
                      <v-col
                        class="d-flex"
                        cols="12"
                        sm="6"
                      >

                        <v-select
                          :items="info.instituciones"
                          label="Sede"
                          solo
                          v-model="altaTurno.institucion_id"
                          item-text="nombre"
                          item-value="id"
                          v-validate="{required: true}"
                          :error-messages="errors.collect('altaTurno.institucion_id')"
                          :data-vv-name="'altaTurno.institucion_id'"
                          data-vv-validate-on="none"
                          @change="obtenerPracticasInstitucion()"
                        ></v-select>
                      </v-col>

                      <v-col
                        class="d-flex"
                        cols="12"
                        sm="6"
                      >

                        <v-autocomplete
                          v-model="altaTurno.practica_id"
                          :items="info.practicasConHorarios"
                          :item-text="'nombre'"
                          :item-value="'id'"
                          label="Estudio o especialidad requerida"
                          v-validate="{required: true}"
                          :error-messages="errors.collect('altaTurno.practica_id')"
                          :data-vv-name="'altaTurno.practica_id'"
                          data-vv-validate-on="none"
                          solo
                          @change="chequearConfirmacion()"
                        ></v-autocomplete>

                      </v-col>

                      <v-col
                        class="d-flex "
                        cols="12"
                        sm="6"
                        style="padding-bottom: 25px;"
                        v-if="!altaTurno.necesita_confirmacion"
                      >
                        <v-select
                          :items="info.horarios"
                          label="Franja Horaria"
                          solo
                          v-model="altaTurno.horario_id"
                          item-text="nombre"
                          item-value="id"
                          :error-messages="errors.collect('altaTurno.horario_id')"
                          :data-vv-name="'altaTurno.horario_id'"
                          data-vv-validate-on="none"
                        ></v-select>
                      </v-col>

                      <v-col
                        class="d-flex"
                        cols="12"
                        sm="12"
                        v-if="!altaTurno.necesita_confirmacion"
                      >
                        <v-label
                          sm="12"
                          class="font-weight-medium"
                        >Días de preferencia</v-label>
                      </v-col>
                      <v-layout
                        wrap
                        v-if="!altaTurno.necesita_confirmacion"
                      >

                        <v-flex
                          xs6
                          sm4
                          md4
                          lg1
                          v-for="item in info.dias"
                          :key="item.id"
                          class="radio-mobile"
                        >
                          <v-checkbox
                            v-model="altaTurno.dias_id"
                            :error-messages="errors.collect('altaTurno.dias_id')"
                            :label="item.nombre"
                            :value="item.id"
                            data-vv-name="altaTurno.dias_id"
                            data-vv-validate-on="none"
                            color="primary"
                          ></v-checkbox>
                        </v-flex>

                      </v-layout>

                      <v-col
                        class="d-flex"
                        cols="12"
                        sm="6"
                      >
                        <v-switch
                          v-if="practicaAdmiteVirtual()"
                          v-model="altaTurno.prefiere_virtual"
                          label="Prefiero turno virtual"
                          :color="'primary'"
                          input-value="true"
                          hide-details
                        ></v-switch>
                      </v-col>

                    </v-row>
                    <v-row>
                      <v-flex
                        sm7
                        offset-sm5
                      >
                        <v-btn
                          v-if="!(!detalleTurno.cargando && detalleTurno.turnoAbierto && !detalleTurno.habilitadoMedico)"
                          color="primary"
                          :class=" { 'white--text' : true, 'btn-login': true }"
                          :loading="buscando"
                          :disabled="buscando"
                          left
                          @click="buscarTurno"
                        >Buscar turnos</v-btn>
                      </v-flex>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="2">
            <!-- TURNO PASO 2 -->
            <div v-if="altaTurno.necesita_confirmacion">
              <v-card
                flat
                tile
                v-if="pasoTurno === 2"
                class="d-flex justify-center mb-6 card"
              >
                <v-card-text>
                  <div class="text-xs-center chips mb-10">
                    <v-chip
                      color="primary"
                      text-color="white"
                      small="true"
                    >
                      {{sedeSeleccionada}}
                    </v-chip>
                    <v-chip
                      color="secondary"
                      text-color="white"
                      small="true"
                    >
                      {{practicaSeleccionada}}
                    </v-chip>
                  </div>
                  <p>&nbsp;</p>
                  <p class="pt-20">Este tipo de turno necesita confirmacion de día y hora por parte del médico.</p>
                  <p>Si desea que nos contactemos con usted para ver cuando hay turnos disponibles por favor haga click en el botón "Continuar"".</p>
                  <p>Muchas gracias.</p>
                  <br><br><br>
                  <v-form v-model="sinValidar">
                    <v-layout>
                      <v-flex
                        md12
                        sm12
                        xs12
                        class="text-sm-left text-xs-left"
                      >
                        <v-btn
                          @click="reiniciarBusqueda()"
                          color="secondary"
                          flat
                          :disabled="buscando"
                          v-if="!buscando"
                        >
                          <v-icon
                            dark
                            left
                          >
                            keyboard_arrow_left
                          </v-icon>
                          Reiniciar busqueda
                        </v-btn>
                      </v-flex>
                      <v-flex
                        md4
                        sm12
                        xs12
                        class="text-sm-rigth text-xs-rigth"
                      >
                        <v-btn
                          color="primary"
                          :class=" { 'white--text' : true, 'btn-login': true }"
                          :loading="guardando"
                          left
                          @click="finalizarAltaTurno"
                        >Continuar</v-btn>

                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-card-text>
              </v-card>
            </div>
            <div v-if="!altaTurno.necesita_confirmacion">
              <v-card
                flat
                tile
                v-if="pasoTurno === 2"
                class="d-flex justify-center mb-6 card"
              >
                <v-card-text>
                  <div class="text-xs-center chips">
                    <v-chip
                      color="primary"
                      text-color="white"
                      small="true"
                    >
                      {{sedeSeleccionada}}
                    </v-chip>
                    <v-chip
                      color="secondary"
                      text-color="white"
                      small="true"
                    >
                      {{practicaSeleccionada}}
                    </v-chip>
                    <v-chip
                      color="primary"
                      text-color="white"
                      small="true"
                    >
                      {{horarioSeleccionado}}
                    </v-chip>

                    <v-chip
                      color="secondary"
                      text-color="white"
                      small="true"
                    >
                      {{diasSeleccionados}}
                    </v-chip>

                  </div>
                  <div class="text-xs-center spinner">
                    <v-progress-circular
                      :size="50"
                      color="primary"
                      indeterminate
                      v-if="buscando"
                    ></v-progress-circular>
                  </div>
                  <h5
                    class="text-center text--secondary pt-10"
                    v-if="turnosDisponibles.length>0 && !buscando"
                  >Seleccione el turno deseado para continuar con la reserva.</h5>
                  <h5
                    class="text-center text--secondary pt-10"
                    v-if="turnosDisponibles.length === 0 && !buscando"
                  >No hay turnos disponibles para la busqueda realizada.</h5>

                  <v-form v-model="valid">
                    <div class="text-center">
                      <v-chip
                        class="ma-2 blue-grey lighten-3"
                        text-color="white"
                        label
                        small="true"
                      >
                        Disponible
                      </v-chip>

                      <v-chip
                        class="indigo lighten-1 blue-grey lighten-3"
                        text-color="white"
                        label
                        small="true"
                      >
                        Turno reservado
                      </v-chip>
                    </div>
                    <v-layout row>
                      <v-flex
                        sm6
                        offset-sm3
                        v-if="!buscando"
                      >
                        <v-list grid-list-sm>
                          <template v-for="(item, index) in turnosDisponibles">
                            <v-list-tile
                              :key="item.fecha"
                              @click="seleccionarTurno(item)"
                              :class="{'turnoPedido indigo lighten-1': item.estado === 'turno', 'indigo lighten-4': item.seleccionado, 'blue-grey lighten-3': !item.seleccionado, 'blanco': true }"
                              sm6
                            >
                              <v-list-tile-action>
                                <v-icon
                                  v-if="item.seleccionado"
                                  color="green"
                                >check</v-icon>
                              </v-list-tile-action>
                              <v-list-tile-content>
                                <v-list-tile-title class="blanco">{{nombreDia(item)}} - {{item.fecha | formatoFecha}} - {{item.hora_desde}} hs</v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                            <v-divider :key="index"></v-divider>
                          </template>
                        </v-list>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex
                        md6
                        sm12
                        xs12
                        class="text-sm-left text-xs-center"
                      >
                        <v-btn
                          @click="semanaAnterior()"
                          color="secondary"
                          flat
                          :disabled="buscando"
                          v-if="this.semanasDisponibles && altaTurno.fecha_desde !== null && this.turnosDisponibles.length > 0"
                        >
                          <v-icon
                            dark
                            left
                          >
                            keyboard_arrow_left
                          </v-icon>
                          Anterior semana
                        </v-btn>
                      </v-flex>

                      <v-flex
                        md6
                        sm12
                        xs12
                        class="text-sm-right text-xs-center"
                      >
                        <v-btn
                          @click="semanaSiguiente()"
                          color="secondary"
                          flat
                          :disabled="buscando"
                          v-if="this.semanasDisponibles && this.turnosDisponibles.length > 0"
                        >
                          Siguiente semana
                          <v-icon
                            right
                            dark
                          >
                            keyboard_arrow_right
                          </v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex
                        md4
                        sm12
                        xs12
                        class="text-sm-left text-xs-left"
                      >
                        <v-btn
                          @click="reiniciarBusqueda()"
                          color="secondary"
                          flat
                          :disabled="buscando"
                          v-if="!buscando"
                        >
                          <v-icon
                            dark
                            left
                          >
                            keyboard_arrow_left
                          </v-icon>
                          Reiniciar busqueda
                        </v-btn>
                      </v-flex>
                      <v-flex
                        md4
                        sm12
                        xs12
                        class="text-sm-rigth text-xs-rigth"
                      >
                        <v-btn
                          color="primary"
                          :class=" { 'white--text' : true, 'btn-login': true }"
                          :loading="guardando"
                          :disabled="altaTurno.turno_seleccionado === null"
                          left
                          @click="mostrarModalRecurrentes"
                          v-if="turnosRecurrentes > 0 && turnosDisponibles.length>0 && !detalleTurno.cargando && !detalleTurno.turnoAbierto && detalleTurno.turnosDisponibles > 1"
                        >Reservar varios turnos</v-btn>
                      </v-flex>
                      <v-flex
                        md4
                        sm12
                        xs12
                        class="text-sm-rigth text-xs-rigth"
                      >
                        <v-btn
                          color="primary"
                          :class=" { 'white--text' : true, 'btn-login': true }"
                          :loading="guardando"
                          :disabled="altaTurno.turno_seleccionado === null"
                          left
                          @click="finalizarAltaTurno"
                          v-if="turnosDisponibles.length>0"
                        >Reservar este turno</v-btn>

                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-card-text>
              </v-card>
            </div>
          </v-stepper-content>

          <v-stepper-content step="3">
            <!-- TURNO PASO 3 -->
            <v-card
              flat
              tile
              v-if="pasoTurno === 3"
              class="d-flex justify-center mb-6 card"
            >
              <v-card-text>

                <div class="text-xs-center chips">
                  <v-chip
                    color="primary"
                    text-color="white"
                  >
                    {{sedeSeleccionada}}
                  </v-chip>
                  <v-chip
                    color="secondary"
                    text-color="white"
                  >
                    {{practicaSeleccionada}}
                  </v-chip>
                  <v-chip
                    color="primary"
                    text-color="white"
                    v-if="!altaTurno.necesita_confirmacion"
                  >
                    {{turnoSeleccionado}}
                  </v-chip>

                </div>
                <div
                  class="text-xs-center documentacion"
                  v-if="altaTurno.agenda_padre_id === null"
                >
                  <h4
                    class="text-left text--secondary pt-10"
                    style="padding-bottom: 10px;"
                  >
                    <u>Documentos que debe presentar en su primera consulta</u>
                  </h4>
                  <h5
                    class="text-left text--secondary"
                    style="padding-bottom: 30px;"
                    v-if="usuario.persona.paciente.obra_social_actual.plan_actual.plan.documentacion_primer_consulta!==null"
                    v-html="html(usuario.persona.paciente.obra_social_actual.plan_actual.plan.documentacion_primer_consulta)"
                  >

                  </h5>
                  <h5 v-if="usuario.persona.paciente.obra_social_actual.plan_actual.plan.documentacion_primer_consulta===null">
                    Sin documentación adicional.
                  </h5>

                  <v-flex
                    xs12
                    sm12
                  >
                    <v-checkbox
                      v-model="aceptaDocumentacion"
                      :error-messages="errors.collect('aceptaDocumentacion')"
                      label="Confirmo tener toda la documentación solicitada"
                      value="true"
                      data-vv-name="aceptaDocumentacion"
                      data-vv-validate-on="none"
                      color="primary"
                      required
                    ></v-checkbox>
                  </v-flex>
                </div>
                <div
                  v-if="solicitaComprobantePago()"
                  class="text-xs-center documentacion-comprobante"
                >
                  <v-layout
                    row
                    wrap
                  >
                    <h5>
                      Comprobante de pago
                    </h5>
                    <v-flex
                      xs8
                      align-center
                      px-0
                    >
                      <span class="file-upload-input-box">
                        <span v-if="fileUploadComprobante.archivos.length > 0"> {{ fileUploadComprobante.archivos[0].name }} </span>
                        <span v-else-if="altaTurno.comprobante_pago"> {{ altaTurno.comprobante_pago }} </span>
                      </span>
                    </v-flex>
                    <v-flex
                      xs4
                      align-center
                      px-0
                    >
                      <vue-upload-component
                        :headers="fileUploadComprobante.headers"
                        :multiple="fileUploadComprobante.multiple"
                        ref="uploadComprobante"
                        v-model="fileUploadComprobante.archivos"
                        :post-action="fileUploadComprobante.urlPost"
                        @input-file="subirArchivoComprobante"
                        input-id="uploadComprobante"
                        class=""
                      >
                        <v-btn
                          color="secondary"
                          small
                          dark
                          :loading="subiendo"
                          class="v-btn--full ma-0"
                        >
                          Seleccionar
                        </v-btn>
                      </vue-upload-component>
                    </v-flex>
                    <v-flex xs12>
                      <span
                        v-if="fileUploadComprobante.error"
                        class="danger--text"
                      >
                        Error: {{ fileUploadComprobante.error }}
                      </span>
                    </v-flex>
                  </v-layout>
                </div>
                <v-layout>
                  <v-flex
                    md6
                    sm12
                    xs12
                    class="text-sm-left text-xs-left"
                  >
                    <v-btn
                      @click="volverPaso(2)"
                      color="secondary"
                      flat
                      :disabled="buscando"
                      v-if="!buscando"
                    >
                      <v-icon
                        dark
                        left
                      >
                        keyboard_arrow_left
                      </v-icon>
                      Volver
                    </v-btn>
                  </v-flex>
                  <v-flex
                    md4
                    sm12
                    xs12
                    class="text-sm-rigth text-xs-rigth"
                  >
                    <v-btn
                      color="primary"
                      :class=" { 'white--text' : true, 'btn-login': true }"
                      :loading="guardando"
                      :disabled="guardando"
                      left
                      @click="solicitarTurno"
                      v-if="!subiendo"
                    >Solicitar turno</v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="4">
            <!-- TURNO PASO 4 -->
            <v-card
              flat
              tile
              v-if="pasoTurno === 4"
              class="d-flex justify-center mb-6 card"
            >
              <v-card-text>
                <h5
                  class="text-center text--secondary pt-10"
                  style="padding-bottom: 30px;"
                  v-if="!paso4NecesitaConfirmacion"
                >Su turno fue reservado con éxito.<br> En caso de ser necesario nos pondremos en contacto con usted.<br>
                  Recibirá la información del turno en su casilla de email</h5>

                <h5
                  class="text-center text--secondary pt-10"
                  style="padding-bottom: 45px;"
                  v-if="paso4NecesitaConfirmacion"
                >Usted será contactado a la brevedad para coordinar un turno.<br> Mucha gracias.</h5>

                <v-row>
                  <v-flex
                    flex
                    sm12
                    text-center
                  >
                    <v-btn
                      color="secondary"
                      :class=" { 'white--text' : true, 'btn-login': true }"
                      left
                      @click="finalizar()"
                    >Finalizar</v-btn>
                  </v-flex>
                </v-row>
              </v-card-text>
            </v-card>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-tab-item>

    <v-tab-item
      :key="'agenda'"
      :value="'tab-agenda'"
    >
      <v-card
        flat
        tile
        v-if="!buscando && agendas.length === 0"
        justify-center
      >
        <v-card-title justify-center>
          <h5 class="text-center text--secondary pt-10">No tiene turnos agendados.</h5>
        </v-card-title>
      </v-card>
      <div class="text-xs-center">
        <v-data-table
          :headers="headersAgenda"
          :headers-length="headersAgenda.length"
          :items="agendas"
          :pagination.sync="paginacionAgenda"
          :total-items="totalItemsAgenda"
          :rows-per-page-items="itemsPorPagina"
          :loading="buscando"
          class="elevation-1"
        >
          <v-progress-linear
            v-slot:progress
            color="blue"
            indeterminate
            v-if="cargando"
          ></v-progress-linear>
          <data-table-header
            slot="headersAgenda"
            slot-scope="props"
            :headers="props.headersAgenda"
            :paginacion="paginacionAgenda"
          >
          </data-table-header>
          <template v-slot:items="props">
            <td class="text-xs-left">{{ props.item.institucion_practica_horario.institucion_practica.practica.nombre }}</td>
            <td class="text-xs-left">{{ props.item.fecha | formatoFecha  }}</td>
            <td class="text-xs-left">{{ props.item.hora_desde  }} hs</td>
            <td class="text-xs-left">{{ props.item.institucion_practica_horario.institucion_practica.institucion.nombre  }}</td>
            <td
              class="text-xs-left"
              v-if="solicitaComprobantePago()"
            >
              <a
                v-if="props.item.comprobante_pago !== null"
                target="_blank"
                @click="descargarComprobantePago(props.item)"
              >Descargar</a>

              <a
                v-if="props.item.comprobante_pago  === null"
                class="rojo"
                href="javascript:void(0)"
                @click="mostrarAdjuntarOrden(props.item)"
              ><small>Adjuntar</small></a>
            </td>
            <td class="column text-xs-center">
              <v-btn
                flat
                small
                color="blue-grey"
                class="mx-0"
                @click="verAgenda(props.item)"
              >
                Ver
              </v-btn>
              <v-btn
                flat
                small
                color="red"
                class="mx-0"
                v-if="props.item.asistido == 0 && fechaFutura(props.item)"
                @click="eliminarAgenda(props.item)"
              >
                <small>Cancelar<br>turno</small>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </div>

      <v-dialog
        v-model="formularioAgenda.mostrar"
        persistent
        transition="dialog-bottom-transition"
        max-width="600px"
        scrollable
        v-if="formularioAgenda.mostrar"
      >
        <v-card class="modal-principal">
          <v-card-title class="titulo">
            <span>Detalle Turno</span>
          </v-card-title>
          <v-divider></v-divider>

          <v-spinner v-if="cargando"></v-spinner>
          <v-card-text
            style="max-height: 100%;"
            v-else
          >
            <v-container grid-list-md>
              <v-layout
                row
                wrap
              >

                <v-flex
                  v-bind="colDetalle"
                  sm6
                >
                  <dt>Sede</dt>
                  <dd>{{itemSeleccionado.institucion_practica_horario.institucion_practica.institucion.nombre}}</dd>
                </v-flex>

                <v-flex
                  v-bind="colDetalle"
                  sm6
                >
                  <dt>Práctica</dt>
                  <dd>{{itemSeleccionado.institucion_practica_horario.institucion_practica.practica.nombre}}</dd>
                </v-flex>

                <v-flex
                  v-bind="colDetalle"
                  sm12
                >
                  <dt>Fecha</dt>
                  <dd>{{nombreDia(itemSeleccionado)}} {{ itemSeleccionado.fecha | formatoFecha  }} {{ itemSeleccionado.hora_desde  }} hs</dd>
                </v-flex>

                <v-flex
                  v-bind="colDetalle"
                  sm6
                >
                  <dt>Orden médica</dt>
                  <dd><a
                      v-if="itemSeleccionado.orden"
                      target="_blank"
                      :href="itemSeleccionado.orden_url"
                    >Descargar</a>
                    <span v-if="!itemSeleccionado.orden">Sin orden</span>
                  </dd>
                </v-flex>

                <v-flex
                  v-bind="colDetalle"
                  sm6
                >
                  <dt>Fecha Orden</dt>
                  <dd>{{itemSeleccionado.fecha_orden | formatoFecha}}</dd>
                </v-flex>

                <v-flex
                  v-bind="colDetalle"
                  sm12
                >
                  <dt>Aclaraciones orden</dt>
                  <dd>{{itemSeleccionado.observaciones}}</dd>
                </v-flex>

              </v-layout>

            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <botones-cancelar-guardar
              v-bind:mostrar-guardar="false"
              v-on:alCancelar="cerrarAgenda"
            ></botones-cancelar-guardar>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="formularioMotivo.mostrar"
        persistent
        transition="dialog-bottom-transition"
        max-width="600px"
        scrollable
      >
        <motivo-cancelacion
          v-if="formularioMotivo.mostrar"
          v-bind="formularioMotivo"
          v-bind:permiso="permiso"
          v-bind:modelo-api="modeloApi"
          v-on:alGuardar="alGuardar"
          v-on:alCerrar="alCerrarMotivo"
        ></motivo-cancelacion>
      </v-dialog>
    </v-tab-item>

    <v-tab-item
      :key="'estudios'"
      :value="'tab-estudios'"
      v-if="puedoPermiso('pacientes_estudios', 'lectura')"
    >
      <div class="text-xs-center">
        <v-data-table
          :headers="headers"
          :headers-length="headers.length+1"
          :items="info.estudios"
          :pagination.sync="paginacion"
          :total-items="info.estudios.length"
          :rows-per-page-items="itemsPorPagina"
          :loading="cargando"
          class="elevation-1"
        >
          <v-progress-linear
            v-slot:progress
            color="blue"
            indeterminate
            v-if="cargando"
          ></v-progress-linear>
          <data-table-header
            slot="headers"
            slot-scope="props"
            :headers="props.headers"
            :paginacion="paginacion"
          >
            <v-btn
              class="white--text text-xs-center"
              round
              color="primary"
              @click="crear"
            >
              <v-icon
                dark
                small
                class="mr-2"
              >add</v-icon>
              Nuevo

            </v-btn>
          </data-table-header>
          <template v-slot:items="props">
            <td class="text-xs-left">{{ props.item.nombre }}</td>
            <td class="text-xs-left">{{ props.item.comentarios  }}</td>
            <td class="text-xs-left">
              <a
                v-if="props.item.archivo"
                href="javascript:void(0)"
                @click="descargarEstudio(props.item)"
                target="_blank"
              >Descargar</a>
            </td>
            <td class="text-xs-left">{{ props.item.fecha | formatoFecha }}</td>

            <td class="column text-xs-right">
              <v-btn
                icon
                flat
                small
                color="blue-grey"
                class="mx-0"
                @click="ver(props.item)"
              >
                <v-icon small>remove_red_eye</v-icon>
              </v-btn>

              <v-btn
                icon
                flat
                small
                color="blue-grey"
                class="mx-0"
                @click="eliminarEstudio(props.item)"
              >
                <v-icon small>delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </div>
      <!-- ALTA -->
      <v-dialog
        v-model="formulario.mostrar"
        persistent
        transition="dialog-bottom-transition"
        max-width="600px"
        scrollable
        v-if="formulario.mostrar"
      >
        <v-card class="modal-principal">
          <v-card-title class="titulo">
            <span>Nuevo Estudio</span>
          </v-card-title>
          <v-divider></v-divider>

          <v-spinner v-if="cargando"></v-spinner>
          <v-card-text
            style="max-height: 100%;"
            v-else
          >
            <v-container grid-list-md>
              <form data-vv-scope="estudio">
                <v-layout
                  row
                  wrap
                >

                  <v-flex
                    xs12
                    sm6
                  >
                    <v-text-field
                      v-model="itemSeleccionado.nombre"
                      :counter="80"
                      solo
                      label="Nombre"
                      v-validate="'required'"
                      :error-messages="errors.collect('estudio.nombre')"
                      data-vv-name="estudio.nombre"
                      data-vv-validate-on="none"
                    ></v-text-field>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                  >
                    <v-text-field
                      v-model="itemSeleccionado.fecha"
                      label="Fecha"
                      v-validate="'required'"
                      :error-messages="errors.collect('estudio.fecha')"
                      data-vv-name="estudio.fecha"
                      data-vv-validate-on="none"
                      type="date"
                      solo
                    ></v-text-field>
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                  >
                    <v-textarea
                      v-model="itemSeleccionado.comentarios"
                      :counter="100"
                      solo
                      label="Comentarios"
                      v-validate="'required'"
                      :error-messages="errors.collect('estudio.comentarios')"
                      data-vv-name="estudio.comentarios"
                      data-vv-validate-on="none"
                    ></v-textarea>
                  </v-flex>

                </v-layout>
                <v-layout
                  row
                  wrap
                >
                  <v-flex
                    xs8
                    align-center
                    px-0
                  >
                    <span class="file-upload-input-box">
                      <span v-if="fileUpload.archivos.length > 0"> {{ fileUpload.archivos[0].name }} </span>
                      <span v-else-if="itemSeleccionado.archivo"> {{ itemSeleccionado.archivo }} </span>
                    </span>
                  </v-flex>
                  <v-flex
                    xs2
                    align-center
                    px-0
                  >
                    <vue-upload-component
                      :headers="fileUpload.headers"
                      :multiple="fileUpload.multiple"
                      ref="upload"
                      v-model="fileUpload.archivos"
                      :post-action="fileUpload.urlPost"
                      @input-file="subirArchivo"
                      input-id="upload"
                      class=""
                    >
                      <v-btn
                        color="secondary"
                        small
                        dark
                        class="v-btn--full ma-0"
                      >
                        Seleccionar
                      </v-btn>
                    </vue-upload-component>
                  </v-flex>
                  <v-flex
                    xs2
                    align-center
                    px-0
                  >
                    <v-btn
                      mx-0
                      color="primary"
                      small
                      dark
                      :loading="subiendo"
                      v-show="fileUpload.mostrarBtnSubir"
                      @click.prevent="$refs.upload.active = true"
                    >
                      Subir
                    </v-btn>
                  </v-flex>
                  <v-flex xs12>
                    <span
                      v-if="fileUpload.error"
                      class="danger--text"
                    >
                      Error: {{ fileUpload.error }}
                    </span>
                  </v-flex>
                </v-layout>
              </form>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <botones-cancelar-guardar
              v-bind:mostrar-guardar="puedoGuardarEstudio()"
              v-bind:guardando="guardando"
              v-on:alGuardar="guardar"
              v-on:alCancelar="cerrar"
            ></botones-cancelar-guardar>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-tab-item>

    <v-dialog
      v-model="modalOrden.mostrar"
      max-width="600px"
      persistent
      scrollable
    >
      <turno-orden
        v-if="modalOrden.mostrar"
        v-bind="modalOrden"
        v-bind:agenda-id="agendaId"
        v-bind:modelo-api="modeloApiPaciente"
        v-on:alGuardar="modalOrden.alGuardar"
        v-on:alCerrar="alCerrarOrden"
      ></turno-orden>
    </v-dialog>

    <v-dialog
      v-model="modalRecurrente.mostrar"
      max-width="600px"
      persistent
      scrollable
    >
      <turno-recurrente
        v-if="modalRecurrente.mostrar"
        v-bind="modalRecurrente"
        v-bind:agenda-id="agendaId"
        v-bind:alta-turno="altaTurno"
        v-bind:detalle-turno="detalleTurno"
        v-bind:turnos-recurrentes="turnosRecurrentes"
        v-bind:modelo-api="modeloApiPaciente"
        v-on:alGuardar="modalRecurrente.alGuardar"
        v-on:alCerrar="alCerrarRecurrente"
        v-on:alCerrarTurno="alCerrarRecurrenteConTurnos"
      ></turno-recurrente>
    </v-dialog>
  </v-tabs>

</template>

<script>
import moment from 'moment'
import mixinAbm from '@/mixins/abm'
import abmFormularioMixin from '@/mixins/abmFormulario'
import abmListadoMixin from '@/mixins/abmListado'
import { formatoFecha } from '@/helpers/filtros'
import _ from 'lodash'
import Combo from '@/api/combo'
import Turno from '@/api/turno'
import Agenda from '@/api/agenda'
import Estudio from '@/api/estudio'
import VueUploadComponent from 'vue-upload-component'
import storageUtil from '@/helpers/storage'
import TurnoOrden from '@/modules/pacientes/pacientes/components/Turnos/TurnoOrden'
import TurnoRecurrente from '@/modules/pacientes/pacientes/components/Turnos/TurnoRecurrente'
import MotivoCancelacion from '@/modules/pacientes/pacientes/components/Turnos/MotivoCancelacion'

export default {
  name: 'DashboardPaciente',
  components: {
    VueUploadComponent, TurnoOrden, MotivoCancelacion, TurnoRecurrente
  },
  mixins: [mixinAbm, abmFormularioMixin, abmListadoMixin],
  filters: {
    formatoFecha
  },
  computed: {
    configuracion () {
      return this.$store.getters.app
    },
    usuario () {
      return this.$store.getters.getUser
    },
    sedeSeleccionada () {
      let vm = this
      return this.info.instituciones.filter(c => c.id === vm.altaTurno.institucion_id)[0].nombre
    },
    horarioSeleccionado () {
      let vm = this

      if (vm.altaTurno.horario_id === null) {
        return 'En cualquier horario'
      }
      return this.info.horarios.filter(c => c.id === vm.altaTurno.horario_id)[0].nombre
    },
    diasSeleccionados () {
      let vm = this
      if (vm.altaTurno.dias_id.length === 0) {
        return 'En cualquier día'
      }
      let diasTxt = ''
      _.forEach(vm.altaTurno.dias_id, item => {
        diasTxt = diasTxt + vm.info.dias.filter(c => c.id === item)[0].nombre + ' - '
      })
      return diasTxt.substring(0, diasTxt.length - 2)
    },
    practicaSeleccionada () {
      let vm = this
      return this.info.practicasConHorarios.filter(c => c.id === vm.altaTurno.practica_id)[0].nombre
    },
    turnosRecurrentes () {
      let vm = this
      return parseInt(this.info.practicasConHorarios.filter(c => c.id === vm.altaTurno.practica_id)[0].turnos_recurrentes)
    },
    turnoSeleccionado () {
      if (this.altaTurno.necesita_confirmacion) {
        return ''
      } else {
        return moment(this.altaTurno.turno_seleccionado.fecha).format('DD/MM/YYYY') + ' ' + this.altaTurno.turno_seleccionado.hora_desde.substring(0, this.altaTurno.turno_seleccionado.hora_desde.length - 3) + ' hs'
      }
    },
    functionEvents () {
      return this.month ? this.monthFunctionEvents : this.dateFunctionEvents
    },
    turnosPorSemana () {
      let vm = this
      let turno = this.info.practicasConHorarios.filter(c => c.id === vm.altaTurno.practica_id)[0]

      let turnos = turno.turnos_por_semana

      if (turno.turnos_por_semana_os !== undefined && turno.turnos_por_semana_os !== null) {
        turnos = turno.turnos_por_semana_os
      }

      if (this.usuario.persona.paciente.obra_social_actual.obra_social.codigo === '3') {
        turnos = 3
      }

      return turnos
    },
    turnosPedidosEnLaSemana () {
      return this.turnosDisponibles.filter(c => c.estado === 'turno').length
    }

  },
  data () {
    return {
      cargando: true,
      guardando: false,
      buscando: false,
      pasoTurno: 1,
      turnosDisponibles: [],
      primerFechaDisponible: null,
      info: {
        agendas: [],
        estudios: [],
        instituciones: [],
        practicasConHorarios: [],
        dias: [
          {
            'id': 2,
            'nombre': 'Lunes'
          },
          {
            'id': 3,
            'nombre': 'Martes'
          },
          {
            'id': 4,
            'nombre': 'Miércoles'
          },
          {
            'id': 5,
            'nombre': 'Jueves'
          },
          {
            'id': 6,
            'nombre': 'Viernes'
          },
          {
            'id': 7,
            'nombre': 'Sábado'
          },
          {
            'id': 1,
            'nombre': 'Domingo'
          }
        ],
        horarios: []
      },
      altaTurno: {
        practica_id: null,
        institucion_id: null,
        horario_id: null,
        fecha_desde: null,
        dias_id: [],
        dias: [],
        observaciones: '',
        fecha_orden: null,
        turno_seleccionado: null,
        orden: null,
        paciente_id: null,
        origen: 'p',
        agenda_actualizar_id: null,
        prefiere_virtual: null,
        necesita_confirmacion: false,
        agenda_padre_id: null,
        comprobante_pago: null,
        turnos_recurrentes: null
      },
      horas: ['08:00', '09:00', '10:00', '11:00', '11:30', '12:00', '12:30', '14:00', '16:30', '17:00', '18:00'],
      agendas: [],
      headersAgenda: [],
      paginacionAgenda: { 'descending': true, 'sortBy': 'fecha' },
      headers: [
        { text: 'Estudio', value: 'estudio', sortable: false },
        { text: 'Comentario', value: 'comentario', sortable: false },
        { text: 'Archivo', value: 'archivo', sortable: false },
        { text: 'Fecha', value: 'fecha', sortable: false }
      ],
      paginacion: { 'descending': true, 'sortBy': 'fecha_desde' },
      fileUpload: {
        headers: {
          Authorization: null
        },
        multiple: false,
        archivos: [],
        mostrarBtnSubir: false,
        urlPost: null,
        error: null
      },
      fileUploadComprobante: {
        headers: {
          Authorization: null
        },
        multiple: false,
        archivos: [],
        mostrarBtnSubir: false,
        urlPost: null,
        error: null
      },
      archivoParaImpactar: null,
      formularioAgenda: {
        mostrar: false,
        item: {},
        operacion: null,
        titulo: 'Editar'
      },
      pasoInicial: 0,
      pacienteOrigenId: null,
      paso4NecesitaConfirmacion: false,
      modalOrden: this.masterModalAccion(),
      modalRecurrente: this.masterModalAccion(),
      formularioMotivo: {
        mostrar: false,
        item: {},
        operacion: null,
        titulo: 'Motivo'
      },
      detalleTurno: {
        cargando: true,
        turnoAbierto: false,
        turnosDisponibles: false
      },
      aceptaDocumentacion: false,
      semanasDisponibles: true
    }
  },
  mounted () {
    let vm = this
    let token = storageUtil.getKey('auth_token')

    vm.altaTurno.prefiere_virtual = vm.prefiereVirtualPorDefecto()
    vm.headersAgenda = vm.solicitaComprobantePago() ? [
      { text: 'Estudio', value: 'practica', sortable: false },
      { text: 'Fecha', value: 'fecha', sortable: false },
      { text: 'Hora', value: 'hora_desde', sortable: false },
      { text: 'Sede', value: 'sede', sortable: false },
      { text: 'Comprobante', value: 'orden', sortable: false },
      { text: 'Acciones', value: 'id', sortable: false, align: 'center' }
    ]
      : [
        { text: 'Estudio', value: 'practica', sortable: false },
        { text: 'Fecha', value: 'fecha', sortable: false },
        { text: 'Hora', value: 'hora_desde', sortable: false },
        { text: 'Sede', value: 'sede', sortable: false },
        { text: 'Acciones', value: 'id', sortable: false, align: 'center' }
      ]

    vm.cargando = false
    vm.fileUpload.urlPost = Estudio.obtenerUrlSubirArchivo()
    vm.fileUpload.headers.Authorization = `Bearer ${token}`
    vm.fileUploadComprobante.urlPost = Agenda.obtenerUrlSubirComprobantePago()
    vm.fileUploadComprobante.headers.Authorization = `Bearer ${token}`
    vm.obtenerDetalleTurno()
  },
  methods: {
    html (texto) {
      if (texto !== '') {
        return texto.replace(/\n/g, '<br />')
      } else {
        return ''
      }
    },
    solicitaComprobantePago () {
      return this.configuracion.configuraciones.solicita_comprobante_pago === 'true'
    },
    prefiereVirtualPorDefecto () {
      return this.configuracion.configuraciones.prefiere_virtual_por_defecto === 'true'
    },
    fechaFutura (item) {
      let fechaTurno = moment(item.fecha + 'T' + item.hora_desde)
      let hoy = moment()

      return (fechaTurno.diff(hoy, 'hours') > 23)
    },
    turnosPedidosEnElDia (fecha) {
      return this.turnosDisponibles.filter(c => c.estado === 'turno' && moment(c.fecha).isSame(moment(fecha), 'day')).length
    },
    practicaAdmiteVirtual () {
      let practicaSeleccionada = _.find(this.info.practicasConHorarios, {
        id: this.altaTurno.practica_id
      })

      if (typeof practicaSeleccionada !== 'undefined' && practicaSeleccionada.admite_virtual) {
        return true
      }

      return false
    },
    cargarInfo () {
      let vm = this
      let dataCombos = {
        instituciones: {
          itemVacio: true
        },
        grupoEntidades: {
          horarios: {
            codigo: 'franja_horaria',
            itemVacio: 'En cualquier horario'
          }
        }
      }

      Combo.listado(dataCombos).then(data => {
        vm.info = _.assign(vm.info, data)
        if (data.instituciones.length === 1) {
          this.altaTurno.institucion_id = data.instituciones[0].id
          this.obtenerPracticasInstitucion()
        }
        vm.cargando = false
      }, error => {
        vm.mostrarError(error)
        vm.soloLectura = true
        vm.cargando = false
      })
    },
    cambiarSolapa (solapa) {
      let vm = this

      console.log(solapa)
      if (solapa === 'tab-agenda') {
        vm.filtrarAgenda()
      }

      if (solapa === 'tab-estudios') {
        vm.filtrarEstudio()
      }
    },
    filtrarAgenda () {
      let vm = this
      let _filtros = _.assign({}, vm.filtros)

      if (vm.buscando) {
        return false
      }

      _filtros.page = vm.paginacionAgenda.page
      _filtros.perPage = vm.paginacionAgenda.rowsPerPage
      _filtros.orderBy = vm.paginacionAgenda.sortBy
      _filtros.sortedBy = vm.paginacionAgenda.descending ? 'desc' : 'asc'

      vm.buscando = true
      Agenda.filtrar(_filtros).then(
        data => {
          vm.agendas.length = 0
          vm.agendas = data.data
          vm.totalItemsAgenda = data.total
          vm.buscando = false
        },
        error => {
          vm.mostrarError(error, true)
          vm.buscando = false
        }
      )
    },
    filtrarEstudio () {
      let vm = this
      let _filtros = _.assign({}, vm.filtros)

      if (vm.buscando) {
        return false
      }

      _filtros.usuario_id = vm.usuario.id
      _filtros.page = vm.paginacionAgenda.page
      _filtros.perPage = vm.paginacionAgenda.rowsPerPage
      _filtros.orderBy = vm.paginacionAgenda.sortBy
      _filtros.sortedBy = vm.paginacionAgenda.descending ? 'desc' : 'asc'

      vm.buscando = true
      Estudio.filtrar(_filtros).then(
        data => {
          vm.info.estudios.length = 0
          vm.info.estudios = data.data
          vm.totalItems = data.total
          vm.buscando = false
        },
        error => {
          vm.mostrarError(error, true)
          vm.buscando = false
        }
      )
    },
    eliminarAgenda (item) {
      let fechaTurno = moment(item.fecha + 'T' + item.hora_desde)
      let hoy = moment()

      if (fechaTurno.diff(hoy, 'hours') < 24) {
        this.mostrarError({ message: 'Los turnos se pueden cancelar hasta 24hs antes.' }, true)
        return false
      }

      if (confirm('¿Seguro desea cancelar el turno?')) {
        this.formularioMotivo = _.assign(this.formularioMotivo, {
          operacion: 'alta',
          titulo: 'Cancelar turno',
          item: {
            id: item.id
          },
          mostrar: true
        })
      }
    },
    alCerrarMotivo () {
      this.formularioMotivo.mostrar = false
      this.filtrarAgenda()
    },
    obtenerPracticasInstitucion () {
      let vm = this

      vm.altaTurno.practica_id = null

      this.info.practicasConHorarios.length = 0
      this.info.practicasConHorarios = []

      if (vm.altaTurno.institucion_id) {
        let info = {
          practicasConHorarios: {
            institucionId: this.altaTurno.institucion_id,
            itemVacio: false,
            habilitada: true
          }
        }

        if (vm.usuario.persona.paciente.obra_social_actual) {
          info.practicasConHorarios.obraSocialPacienteId = vm.usuario.persona.paciente.obra_social_actual.obra_social_id
        }

        Combo.listado(info).then(data => {
          _.forEach(data.practicasConHorarios, item => {
            item.admite_virtual = item.admite_virtual === '1'
            item.confirmacion = item.confirmacion === '1'
          })
          if (data.practicasConHorarios.length === 1) {
            this.altaTurno.practica_id = data.practicasConHorarios[0].id
          }
          vm.llenarCombos(data)
        })
      }
    },
    chequearConfirmacion () {
      this.altaTurno.necesita_confirmacion = this.info.practicasConHorarios.find(obj => {
        return obj.id === this.altaTurno.practica_id
      }).confirmacion
    },
    llenarCombos (data) {
      let vm = this
      vm.info = _.assign(vm.info, data)
    },
    volverPaso (paso) {
      this.pasoTurno = paso
    },
    nombreDia (item) {
      let vm = this
      let dia = vm.info.dias.filter(c => c.id === parseInt(item.dia_numero))

      return dia[0].nombre
    },
    filtrarDatos () { },
    allowedDates: val => true,
    formatoFecha () {
      return moment(this.picker).format('ddd, MMM D YYYY')
    },
    practicaNecesitaProfesional () {
      if (this.altaTurno.practica_id === null) {
        return false
      }
      let vm = this

      return this.info.practicasConHorarios.find(obj => {
        return obj.id === vm.altaTurno.practica_id
      }).necesita_profesional
    },
    seleccionarTurno (turno) {
      if (turno.seleccionado) {
        this.deseleccionarTurnos()
      } else {
        if (turno.estado !== 'turno') {
          if (this.turnosPedidosEnLaSemana < this.turnosPorSemana) {
            if (this.turnosPedidosEnElDia(turno.fecha) === 0) {
              this.deseleccionarTurnos()
              turno.seleccionado = true
              this.altaTurno.turno_seleccionado = turno
              this.semanasDisponibles = false
            } else {
              this.mostrarError({ message: 'Ya tenes un turno solicitado ese mismo día.' }, true)
            }
          } else {
            this.mostrarError({ message: 'Llegaste al límite de turnos para esta semana.' }, true)
          }
        }
      }
    },
    deseleccionarTurnos () {
      _.forEach(this.turnosDisponibles, item => {
        item.seleccionado = false
      })
      this.semanasDisponibles = true
      this.altaTurno.turno_seleccionado = null
    },
    buscarTurno () {
      let vm = this

      vm.$validator.validate().then(valid => {
        if (valid) {
          vm.turnosDisponibles = []
          vm.buscando = true
          Agenda.buscarTurno(vm.altaTurno).then(
            data => {
              vm.$set(vm, 'turnosDisponibles', _.cloneDeep(data))

              vm.pasoTurno = 2
              if (vm.primerFechaDisponible === null && vm.turnosDisponibles.length > 0) {
                vm.primerFechaDisponible = this.turnosDisponibles[0].fecha
              }
              if (vm.turnosDisponibles.length > 0 && moment(this.turnosDisponibles[0].fecha).isSame(moment(vm.primerFechaDisponible), 'week')) {
                vm.altaTurno.fecha_desde = null
              }
              vm.buscando = false
            },
            error => {
              vm.buscando = false
              if (error.type === 422) {
                vm.mostrarErroresEnCampos(error)
              } else {
                vm.mostrarError(error, true)
              }
            }
          )
        }
      })
    },
    semanaSiguiente () {
      this.deseleccionarTurnos()
      this.altaTurno.fecha_desde = moment(this.turnosDisponibles[0].fecha).add(1, 'weeks').startOf('isoWeek')
      this.buscarTurno()
    },
    semanaAnterior () {
      this.deseleccionarTurnos()
      this.altaTurno.fecha_desde = moment(this.turnosDisponibles[0].fecha).subtract(1, 'weeks').startOf('isoWeek')
      this.buscarTurno()
    },
    reiniciarBusqueda () {
      this.altaTurno.fecha_desde = null
      this.pasoTurno = 1
    },
    finalizarAltaTurno () {
      if (!this.altaTurno.necesita_confirmacion && this.altaTurno.turno_seleccionado === null) {
        this.mostrarError({ message: 'Por favor seleccione un turno para continuar.' }, true)
        return false
      }

      if (this.solicitarDocumentacion()) {
        this.pasoTurno = 3
      } else {
        if (this.solicitaComprobantePago()) {
          this.pasoTurno = 3
        } else {
          this.solicitarTurno()
        }
      }
    },
    solicitarDocumentacion () {
      return !(!this.detalleTurno.cargando && !this.detalleTurno.turnoAbierto && this.detalleTurno.turnosDisponibles > 0)
    },
    solicitarTurno () {
      if (!this.solicitaComprobantePago()) {
        if (this.pasoTurno === 3 && !this.aceptaDocumentacion) {
          this.mostrarError({ message: 'Por favor confirme tener toda la documentación.' }, true)
          return false
        }
      } else {
        if (this.altaTurno.agenda_padre_id === null && !this.aceptaDocumentacion) {
          this.mostrarError({ message: 'Por favor confirme tener toda la documentación.' }, true)
          return false
        }
      }
      let vm = this
      vm.paso4NecesitaConfirmacion = vm.altaTurno.necesita_confirmacion
      vm.guardando = true
      Agenda.guardar(vm.altaTurno).then(
        data => {
          vm.mostrarMensajeOk()
          vm.info.agendas.push(_.cloneDeep(data))
          vm.altaTurno = {
            practica_id: vm.info.practicasConHorarios.length === 1 ? vm.info.practicasConHorarios[0].id : null,
            institucion_id: vm.info.instituciones.length === 1 ? vm.info.instituciones[0].id : null,
            horario_id: null,
            fecha_desde: null,
            dias_id: [],
            dias: [],
            observaciones: '',
            fecha_orden: null,
            turno_seleccionado: null,
            origen: 'p',
            agenda_actualizar_id: null,
            prefiere_virtual: this.prefiereVirtualPorDefecto(),
            necesita_confirmacion: false,
            turnos_recurrentes: null
          }

          vm.guardando = false
          vm.pasoTurno = 4

          vm.semanasDisponibles = true
        },
        error => {
          vm.guardando = false
          vm.mostrarError(error, true)
        }
      )
    },
    eliminarTurno (item) {
      let vm = this
      Turno.eliminar(item.id).then(() => {
        let index = _.findIndex(vm.info.turnos, { id: item.id })
        vm.info.turnos.splice(index, 1)
      })
    },
    crear () {
      this.itemSeleccionado = {
        id: 0,
        nombre: null,
        comentarios: null,
        fecha: null
      }
      this.formulario = _.assign(this.formulario, {
        operacion: 'alta',
        titulo: 'Crear',
        item: this.itemSeleccionado,
        mostrar: true
      })
    },
    verAgenda (item) {
      this.itemSeleccionado = _.clone(item)
      this.formularioAgenda = _.assign(this.formularioAgenda, {
        operacion: 'lectura',
        titulo: 'Ver',
        item: item,
        mostrar: true
      })
    },
    cerrarAgenda () {
      this.formularioAgenda.mostrar = false
    },
    ver (item) {
      this.itemSeleccionado = _.clone(item)
      this.formulario = _.assign(this.formulario, {
        operacion: 'modif',
        titulo: 'Modificar',
        item: this.itemSeleccionado,
        mostrar: true
      })
    },
    puedoGuardarEstudio () {
      return !this.subiendo
    },
    guardar () {
      let vm = this

      if (vm.guardando) {
        return false
      }

      vm.$validator.validateAll('estudio').then(valid => {
        if (valid) {
          if (!vm.itemSeleccionado.archivo) {
            alert('Debe cargar un estudio')
            return false
          }

          vm.ocultarAlerta()
          vm.guardando = true
          // vm.itemSeleccionado.archivo = vm.archivoParaImpactar ? vm.archivoParaImpactar : null
          Estudio.guardar(vm.itemSeleccionado).then(
            data => {
              vm.mostrarMensajeOk()

              if (vm.itemSeleccionado.id) {
                let index = _.findIndex(vm.info.estudios, { id: vm.itemSeleccionado.id })
                vm.info.estudios.splice(index, 1, data)
              } else {
                vm.info.estudios.unshift(_.cloneDeep(data))
              }

              vm.cerrar()

              vm.guardando = false
            },
            error => {
              vm.guardando = false
              if (error.type === 422) {
                vm.mostrarErroresEnCampos(error)
              } else {
                vm.mostrarError(error)
              }
            }
          )
        } else {
          console.debug(vm.errors)
          vm.guardando = false
        }
      })
    },
    cerrar () {
      this.formulario.mostrar = false
    },
    descargarEstudio (item) {
      Estudio.descargar(item.id)
    },
    eliminarEstudio (item) {
      let vm = this
      Estudio.eliminar(item.id).then(() => {
        let index = _.findIndex(vm.info.estudios, { id: item.id })
        vm.info.estudios.splice(index, 1)
      })
    },
    subirOrden (newFile, oldFile) {
      this.subirArchivo(newFile, oldFile, 'uploadOrden')
    },
    subirArchivo (newFile, oldFile, ref) {
      var vm = this
      var _ref = typeof ref !== 'undefined' ? ref : 'upload'

      if (newFile && newFile.active && !newFile.success) {
        vm.subiendo = true
      }

      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!vm.$refs[_ref].active) {
          vm.fileUpload.mostrarBtnSubir = true
          vm.fileUpload.error = null
          vm.subiendo = false
          vm.$refs[_ref].active = true
        }
      }

      if (newFile && oldFile) {
        if (newFile.success) {
          if (_ref === 'uploadOrden') {
            vm.altaTurno.orden = newFile.response.file
          } else {
            vm.itemSeleccionado.archivo = newFile.response.file
          }

          vm.$refs[_ref].clear()
          vm.fileUpload.mostrarBtnSubir = false
          vm.subiendo = false
          // onSuccess(newFile)
        }
        if (newFile.error) {
          switch (newFile.error) {
            case 'extension':
              vm.fileUpload.error = 'El archivo seleccionado debe ser .xlsx'
              break
            default:
              vm.fileUpload.error = newFile.error
              vm.$refs[_ref].clear()
              vm.fileUpload.mostrarBtnSubir = false
              break
          }

          vm.subiendo = false
        }
      }
    },
    subirArchivoComprobante (newFile, oldFile, ref) {
      var vm = this
      var _ref = 'uploadComprobante'

      if (newFile && newFile.active && !newFile.success) {
        vm.subiendo = true
      }

      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!vm.$refs[_ref].active) {
          vm.fileUploadComprobante.mostrarBtnSubir = true
          vm.fileUploadComprobante.error = null
          vm.subiendo = false
          vm.$refs[_ref].active = true
        }
      }

      if (newFile && oldFile) {
        if (newFile.success) {
          vm.altaTurno.comprobante_pago = newFile.response.file

          vm.$refs[_ref].clear()
          vm.fileUploadComprobante.mostrarBtnSubir = false
          vm.subiendo = false
          // onSuccess(newFile)
        }
        if (newFile.error) {
          switch (newFile.error) {
            case 'extension':
              vm.fileUploadComprobante.error = 'El archivo seleccionado debe ser .xlsx'
              break
            default:
              vm.fileUploadComprobante.error = newFile.error
              vm.$refs[_ref].clear()
              vm.fileUploadComprobante.mostrarBtnSubir = false
              break
          }

          vm.subiendo = false
        }
      }
    },
    mostrarAdjuntarOrden (item) {
      let vm = this
      vm.agendaId = item.id
      vm.modalOrden = _.assign(this.masterModalAccion(), {
        titulo: 'Adjuntar Orden',
        operacion: 'modif',
        permiso: 'pacientes_turnos',
        mostrar: true
      })
    },
    alCerrarOrden () {
      this.filtrarAgenda()
      this.modalOrden.mostrar = false
    },
    descargarComprobantePago (item) {
      return Agenda.descargarComprobantePago(item.id)
    },
    obtenerDetalleTurno () {
      let vm = this
      Agenda.detalleTurno('p', []).then(
        data => {
          vm.detalleTurno.turnoAbierto = data.turnoAbierto
          vm.detalleTurno.turnosDisponibles = data.turnosDisponibles
          vm.detalleTurno.cargando = false
          vm.altaTurno.agenda_padre_id = data.agenda_padre_id
        },
        error => {
          vm.mostrarError(error, true)
          vm.buscando = false
        }
      )
    },
    finalizar () {
      this.obtenerDetalleTurno()
      this.volverPaso(1)
    },
    mostrarModalRecurrentes (item) {
      let vm = this
      vm.agendaId = item.id
      vm.modalRecurrente = _.assign(this.masterModalAccion(), {
        titulo: 'Turnos recurrentes',
        operacion: 'modif',
        permiso: 'pacientes_turnos',
        mostrar: true
      })
    },
    alCerrarRecurrente () {
      this.modalRecurrente.mostrar = false
    },
    alCerrarRecurrenteConTurnos () {
      let vm = this
      this.modalRecurrente.mostrar = false

      vm.altaTurno = {
        practica_id: vm.info.practicasConHorarios.length === 1 ? vm.info.practicasConHorarios[0].id : null,
        institucion_id: vm.info.instituciones.length === 1 ? vm.info.instituciones[0].id : null,
        horario_id: null,
        fecha_desde: null,
        dias_id: [],
        dias: [],
        observaciones: '',
        fecha_orden: null,
        turno_seleccionado: null,
        origen: 'p',
        agenda_actualizar_id: null,
        prefiere_virtual: this.prefiereVirtualPorDefecto(),
        necesita_confirmacion: false,
        turnos_recurrentes: null
      }

      vm.guardando = false
      vm.pasoTurno = 4

      vm.semanasDisponibles = true
    }
  },
  watch: {
    paginacionAgenda: {
      handler (nuevo, viejo) {
        this.filtrarAgenda()
      },
      deep: true
    }
  }

}
</script>

<style lang="scss" scoped>
dt {
  font-weight: 100;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.54);
}
.v-tabs__wrapper {
  background-color: #e41b23 !important;
}
.file-upload-input-box {
  border: 1px solid #e0e0e0;
  border-right: none;
  border-radius: 5px 0 0 5px;
  height: 28px;
  padding: 0 10px;
}
.v-btn--full {
  width: 100%;
  cursor: pointer !important;
}
h5 {
  padding-top: 20px;
}
.chips {
  padding-top: 15px;
}
.spinner {
  padding-top: 100px;
}
.blanco {
  color: #ffffff;
  font-weight: 100 !important;
}
.card {
  min-height: 180px;
}
.v-list {
  height: 300px !important; /* or any height you want */
  overflow-y: auto;
  z-index: 99999;
}
/* width */
::-webkit-scrollbar {
  width: 12px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.rojo {
  color: red;
}
.verde {
  color: #5e4295 !important;
}
.turnoPedido {
  cursor: default;
}
.documentacion {
  width: 34%;
  display: block;
  margin: 31px auto;
  margin-bottom: 0px;
}
.documentacion-comprobante {
  width: 30%;
  display: block;
  margin: 3px auto;
  margin-bottom: 30px;
}
.radio-mobile {
  display: flex;
  flex-wrap: wrap;
}
.v-list {
  z-index: 1 !important;
}
@media only screen and (max-width: 600px) {
  .v-list__tile__action {
    min-width: 14px !important;
  }
  .radio-mobile:after {
    content: '\a';
    white-space: pre;
  }
}
</style>
